export const themeColors = [
  {color: [0, 145, 234], gradient: [[0,145,234, 1], [0,145,234, 0.75], [0,212,255, 1]], name: 'blue'},
  {color: [251,192,45], gradient: [[251,192,45, 1], [251,192,45, 0.75], [255,214,0, 1]], name: 'yellow'},
  {color: [46,125,50], gradient: [[46,125,50, 1], [46,125,50, 0.75], [56,142,60, 1]], name: 'green'},
  {color: [198,40,40], gradient: [[198,40,40, 1], [198,40,40, 0.75], [211,47,47, 1]], name: 'red'},
  {color: [0, 0, 0], gradient: [[0,0,0, 1], [0,0,0, 0.9], [51,51,51, 1]], name: 'black'}
]